import React, { useState, useEffect } from 'react';
import { getAppointments } from '../../api';
import useAccionesTurno from '../../hooks/useAccionesTurno';
import { ordenarTurnosPorHorario } from '../../utils/ordenarTurnos';
import TurnoPopover from '../../components/TurnoPopover';
import TurnoModals from '../../components/TurnoModals';
import './PendientesDelDia.css';

// Turnos/eventos de la fecha `fecha` (YYYY-MM-DD), reutilizando el mismo
// endpoint (GET /api/appointments/?date=) y el mismo flujo de
// editar/cancelar/ver-ficha que ya existe en Calendario.jsx.
function PendientesDelDia({ fecha, onVerFicha, refreshSignal, pacientes, onPacienteActualizado }) {
  const [citas, setCitas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [errorCarga, setErrorCarga] = useState('');
  const [popover, setPopover] = useState(null);

  const acciones = useAccionesTurno({ citas, setCitas, onError: setErrorCarga, pacientes, onPacienteActualizado });

  useEffect(() => {
    let cancelado = false;
    setCargando(true);
    getAppointments({ date: fecha })
      .then((data) => { if (!cancelado) { setCitas(data); setErrorCarga(''); } })
      .catch(() => { if (!cancelado) setErrorCarga('Error al cargar los turnos de hoy.'); })
      .finally(() => { if (!cancelado) setCargando(false); });
    return () => { cancelado = true; };
  }, [fecha, refreshSignal]);

  const citasOrdenadas = ordenarTurnosPorHorario(citas);

  const abrirPopover = (e, cita) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.min(rect.left, window.innerWidth - 285);
    const y = Math.min(rect.bottom + 6, window.innerHeight - 220);
    setPopover({ cita, x, y });
  };

  return (
    <div className="pendientes-del-dia">
      <h3 className="pendientes-titulo">Pendientes de hoy</h3>

      {cargando ? (
        <p className="sesiones-vacio">Cargando...</p>
      ) : errorCarga && citasOrdenadas.length === 0 ? (
        <div className="cal-error">{errorCarga}</div>
      ) : citasOrdenadas.length === 0 ? (
        <p className="sesiones-vacio">No tenés pendientes para hoy.</p>
      ) : (
        <div className="cal-citas-lista">
          {citasOrdenadas.map((c) => (
            <div
              key={c.id}
              className={`cal-cita-item pendiente-item ${c.is_event ? 'cal-cita-item-evento' : ''}`}
              onClick={(e) => abrirPopover(e, c)}
            >
              <div className="cal-cita-info">
                <span className="cal-cita-tipo-badge">{c.is_event ? 'Evento' : 'Turno'}</span>
                <span className="cal-cita-nombre">{c.patient_name}</span>
                {c.notes && <span className="cal-cita-notas">{c.notes}</span>}
              </div>
              <span className="cal-cita-hora">{c.time ? c.time.slice(0, 5) : 'Sin horario'}</span>
            </div>
          ))}
        </div>
      )}

      {popover && (
        <TurnoPopover
          cita={popover.cita}
          x={popover.x}
          y={popover.y}
          onCerrar={() => setPopover(null)}
          onEditar={(cita) => { acciones.abrirEdicion(cita); setPopover(null); }}
          onVerFicha={onVerFicha ? (patientId) => { onVerFicha(patientId); setPopover(null); } : null}
          onCancelar={(id) => { acciones.iniciarCancelar(id); setPopover(null); }}
          onRenombrar={(cita) => { acciones.iniciarRenombrar(cita); setPopover(null); }}
          cancelando={acciones.cancelando}
        />
      )}

      <TurnoModals acciones={acciones} />
    </div>
  );
}

export default PendientesDelDia;
